import { handleActions } from 'redux-actions';
import { setFeatureFlags } from './actions';

interface FeatureFlagState {
  sdgIntegration: boolean
}

const initialState: FeatureFlagState = {
  sdgIntegration: false,
};

const reducer = handleActions({
  [setFeatureFlags.toString()]: (state, { payload }) => ({
    ...state,
    sdgIntegration: payload.sdgIntegration,
  }),
}, initialState);

export { reducer };
export type { FeatureFlagState };
